function buildShortMessage(shareUrl: string) {
  return `Hey! I booked a trip with BCC and I got a good deal. You could get $200 as a new user if you book within 90 days, and I’ll earn $200 after you fly. A nice bonus for both of us! Use my referral link: ${shareUrl}`;
}

function buildEmailMessage(shareUrl: string) {
  return `Hey!

I booked a trip with BCC and got a good deal, so I thought I’d share it with you!

As a new BCC customer, you could get $200 in travel credit if you book within 90 days of submitting your trip request. You can fly later, too!

I’ll earn $200 after you fly. A nice bonus for both of us!

Use my referral link: ${shareUrl}`;
}

export function buildReferralShareLinks(shareUrl: string) {
  const shortMessage = encodeURIComponent(buildShortMessage(shareUrl));
  const emailMessage = encodeURIComponent(buildEmailMessage(shareUrl));

  return {
    mail: `mailto:?subject=${encodeURIComponent('Book with BCC')}&body=${emailMessage}`,
    sms: `sms:?&body=${shortMessage}`,
    whatsApp: `https://wa.me/?text=${shortMessage}`,
  };
}
